import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'App.css';
import ErrorBoundary from 'Common/ErrorBoundary';
import * as AmendContractActions from 'Redux/Actions/AmendContract.Actions';
import AmendContractTeamTable from '../../Components/Amendments/Teams/AmendContractTeamTable';
import AmendContractDetails from '../../Components/Amendments/Details/AmendContractDetails';
import moment from 'moment';
import Refiner from 'Common/Components/Refiner/Refiner.container';
import Page from 'Common/Layout/Page';
import Section from 'Common/Layout/Section';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';

const refinerFields = [
    { name: 'appointmentType', label: "Marking Type", type: 'list', allowEmpty: true },
    { name: 'markingTeamTitle', label: 'Team Name contains', type: 'text' },
	{ name: 'markingTeamCode', label: 'Code contains', type: 'text' }
];

class AmendContract extends Component {
	constructor(props) {
        super(props);

		this.state = {
			selectedYear: this.props.contract_globals.qualification_year.selected,
			contractTypes: this.props.contract_globals.appointment_types.selected,
			keyField: 'markingTeamId',
			pageNo: 1,
			pageSize: 50,
			sortOrder: 'asc',
			sortField: 'markingTeamTitle',
            searchText: '',
            searchYear: this.props.contract_globals.qualification_year.selected.toString(),
			total: 0,
			apiCallCompleted: false,
			amendContractTeam: [],
			refinerData: [],
			visibleTeams: [],
			markingTeamId: 0,
			appointmentType: '',
			teamTitle: '',
			teamCode: '',
			flagDetailsDisplay: false,
			amendContractDetails: [],
			amendmentReason: props.amendContractReducer.amendmentReason || [],
			displaySubScreen: 'detailsTable',
			amendmentIDs: [],
			amendmentNumber: 0,
			amendmentDate: '',
			amendmentReasonIDs: [],
			dbUpdate: false,
			chkDeleteActionChecked: false,
			teamRowSelectionChange: false,
			refinerOpen: true,
			key: Math.random()
		};
		this.componentRef = React.createRef();
		this.btnBack = React.createRef();
	}

	componentWillUnmount = () => {
		this.props.clearAllAmendUpdates();
	};

	loadAmendContractTeamsData = async (page, sizePerPage, sortOrder, sortField, searchText = '', isBackToTeamPage = false, type = '') => {
 		const { contractTypes, markingTeamId, searchYear } = this.state;
        
		let query = {
            sortOrder: sortOrder,
            sortField: sortField,
            page: 0,
            sizePerPage: 1000,
            searchText: '',
            flagExportData: false
        };

		await this.props.getAmendContractTeam(searchYear, contractTypes, query);
        
		let initMarkingTeamId = 0,
			appointmentType = '',
			teamTitle = '',
			teamCode = '',
			amendmentNumber = 0,
			amendmentDate = '';
		let amendContractTeam = this.props.amendContractReducer.amendContractTeam;

		if (amendContractTeam.length > 0) {
			let item;
			if (isBackToTeamPage && markingTeamId > 0) item = amendContractTeam.find(x => x.markingTeamId === markingTeamId);
			else item = amendContractTeam[0];
			if (item) {
				initMarkingTeamId = item.markingTeamId;
				appointmentType = item.appointmentType;
				teamTitle = item.markingTeamTitle;
				teamCode = item.markingTeamCode;
				amendmentNumber = item.amendmentNumber;
				amendmentDate = item.amendmentDate;
			}
		}

		if (type !== 'sort')
		{
			this.setState({
				refinerData: this.props.amendContractReducer.amendContractTeam,
			});	
		}

		this.setState({
			...this.state,
 			sortOrder,
			sortField,
			pageNo: page,
			pageSize: sizePerPage,
			searchText,
			apiCallCompleted: this.props.amendContractReducer.apiCallCompleted,
			total: this.props.amendContractReducer.total,
			amendContractTeam: this.props.amendContractReducer.amendContractTeam,
			visibleTeams: this.props.amendContractReducer.amendContractTeam,
			markingTeamId: initMarkingTeamId,
 			appointmentType,
			teamTitle,
			teamCode,
			dbUpdate: false,
			amendmentNumber,
			amendmentDate,
			teamRowSelectionChange: true
		});
	};

	getAmendmentReasonsList = async () => {
		await this.props.getAmendmentReason();
		this.setState({ amendmentReason: this.props.amendContractReducer.amendmentReason });
	};

	onTeamTableChange = async (type, state) => {
 		let { sortOrder, sortField, page, sizePerPage, searchText, searchYear } = state;

		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'markingTeamTitle';
		page = type === 'search' ? 1 : page;

		await this.loadAmendContractTeamsData(page, sizePerPage, sortOrder, sortField, searchText, searchYear, type);
		this.setState({  pageNo: page, pageSize: sizePerPage });
        
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	onRefinementChange = async (refined) => {
		this.setState({ visibleTeams: refined });
	};
	
	onRefinerToggle = async () => {
		const { refinerOpen } = this.state;
		this.setState({ refinerOpen: !refinerOpen });
	};

	getExportData = async props => {
		const { visibleTeams } = this.state;
		props.onExport(visibleTeams);
	};

	getExportAmendContractDetails = async props => {
		let { selectedYear, markingTeamId, appointmentType } = this.state;
		const query = {
			sortOrder: 'asc',
			sortField: 'amendmentNumber',
			page: 0,
			sizePerPage: 0,
			searchText: '',
			flagExportData: true
		};
		await this.props.getAmendContractDetails(selectedYear, markingTeamId, appointmentType, query);
		props.onExport(this.props.amendContractReducer.amendContractDetailsExport);
	};

	onSelectTeamRow = (row, isSelect) => {
		this.setState(() => ({
			markingTeamId: row.markingTeamId,
			appointmentType: row.appointmentType,
			teamTitle: row.markingTeamTitle,
			teamCode: row.markingTeamCode,
			amendmentNumber: row.amendmentNumber || 0,
			amendmentDate: row.amendmentDate || '',
			teamRowSelectionChange: true,
			chkDeleteActionChecked: false
		}),
		() => this.onSelectClick());
	};

	onSelectClick = () => {
 		let flagDetailsDisplay = this.state.flagDetailsDisplay;
		
		if (!flagDetailsDisplay) {
			this.setState({ flagDetailsDisplay: true });
			if (this.state.teamRowSelectionChange) this.fetchAmendContractDetails();
		} else if (flagDetailsDisplay) {
			if (this.state.displaySubScreen === 'detailsTable') {
				this.setState({ flagDetailsDisplay: false });
				const { pageNo, pageSize, sortOrder, sortField, searchText, selectedYear } = this.state;
				let isBackToTeamPage = true;
				this.setState({ total: 0, apiCallCompleted: false, amendContractDetails: [] });
                this.loadAmendContractTeamsData(pageNo, pageSize, sortOrder, sortField, searchText, isBackToTeamPage, selectedYear);
                
			} else {
				if (this.state.dbUpdate) this.fetchAmendContractDetails();
				else this.updatePropsWithDetailsTableLastRow();
				this.setState({ displaySubScreen: 'detailsTable' });
			}
		}
	};

	fetchAmendContractDetails = async () => {
		this.setState({
			amendContractDetails: [],
			apiCallCompleted: false,
			amendmentIDs: [],
			amendmentNumber: 0,
			amendmentDate: '',
			amendmentReasonIDs: []
		});
		const { selectedYear, markingTeamId, appointmentType } = this.state;
		let query = {
			sortOrder: 'asc',
			sortField: 'amendmentNumber',
			page: 1,
			sizePerPage: 10,
			searchText: '',
			flagExportData: false
		};
		await this.props.getAmendContractDetails(selectedYear, markingTeamId, appointmentType, query);
		this.setState({
			...this.state,
			apiCallCompleted: this.props.amendContractReducer.apiCallCompleted,
			amendContractDetails: this.props.amendContractReducer.amendContractDetails,
			teamRowSelectionChange: false,
			markingTeamId,
			chkDeleteActionChecked: false
		});
		this.updatePropsWithDetailsTableLastRow();
	};

	updatePropsWithDetailsTableLastRow = () => {
		let detailsLength = Object.keys(this.state.amendContractDetails).length;
		if (detailsLength > 0) {
			let item = this.state.amendContractDetails[detailsLength - 1];

			if (item)
				this.setState({
					amendmentIDs: item.amendmentIds,
					amendmentNumber: item.amendmentNumber,
					amendmentDate: item.amendmentDate,
					amendmentReasonIDs: item.amendmentReasonIds
				});
		}
	};
	
	onAddClick = () => {
		if (this.state.amendmentReason.length === 0) this.getAmendmentReasonsList();
		this.setState({ displaySubScreen: 'detailsForm', amendmentDate: null, amendmentReasonIDs: [] });
		let amendContractDetails = this.state.amendContractDetails;
		if (amendContractDetails.length === 0) this.setState({ amendmentNumber: 1 });
		else if (amendContractDetails.length > 0) {
			let index = amendContractDetails.length - 1;
			let items = amendContractDetails[index];
			if (items) this.setState({ amendmentNumber: items.amendmentNumber + 1 });
		}
	};

	onEditClick = () => {
		if (this.state.amendmentReason.length === 0) this.getAmendmentReasonsList();
		this.setState({ displaySubScreen: 'detailsForm' });
	};

	onChangeDeleteCheckbox = event => {
		event.persist();
		if (event.target.checked) this.setState({ chkDeleteActionChecked: true });
		else this.setState({ chkDeleteActionChecked: false });
	};

	onDateChange = selectedDate => {
		let formattedDate = selectedDate;
		if (isNaN(Date.parse(selectedDate))) formattedDate = moment(selectedDate).format('DD/MM/YYYY');
		this.setState({ amendmentDate: formattedDate });
		this.props.addUpdateToAmendContract(true);
	};

	dateValidate = amendmentDate => {
		if (isNaN(Date.parse(amendmentDate))) {
			this.props.showToastMessage('error', 'Amendment date is invalid.');
			return false;
		}

		let selectedDate = new Date(amendmentDate);
		if (selectedDate.getFullYear() && selectedDate.getMonth() && selectedDate.getDate()) {
			let currentDate = new Date();
			currentDate = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
			selectedDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));
			if (selectedDate < currentDate) {
				this.props.showToastMessage('error', 'Amendment date is less than current date.');
				return false;
			}
		}

		return true;
    };

    updateYear = async year => {
        this.state.searchYear = year;
        var isBackToTeamPage = false;
    	const { pageNo, pageSize, sortOrder, sortField, searchText } = this.state;

		await this.loadAmendContractTeamsData(pageNo, pageSize, sortOrder, sortField, searchText, isBackToTeamPage);

		//	Refresh the pagination
		this.setState({ key: Math.random() });
	};

	onReaonsCheckboxChange = (event, reasonID) => {
		let arrAmendmentReasons = this.state.amendmentReasonIDs;
		let matchData = arrAmendmentReasons.find(rowReasonIDs => rowReasonIDs === reasonID);
		if (event.target.checked) {
			if (arrAmendmentReasons.length === 6) {
				this.props.showToastMessage('warning', 'Max number of adding Amendment Reasons is 6');
				return false;
			} else {
				if (!matchData) arrAmendmentReasons.push(reasonID);
			}
		} else {
			if (matchData) {
				let index = arrAmendmentReasons.indexOf(reasonID);
				arrAmendmentReasons.splice(index, 1);
			}
		}
		this.setState({ amendmentReasonIDs: arrAmendmentReasons });
		this.props.addUpdateToAmendContract(true);
	};

	onSubmitClick = async () => {
		const { markingTeamId, appointmentType, selectedYear, amendmentNumber, amendmentDate, amendmentReasonIDs } = this.state;

		if (!amendmentDate && amendmentReasonIDs.length === 0) {
			this.props.showToastMessage('error', 'Amendment Date and Amendment Reason are required. Please update.');
			return false;
		} else if (!this.dateValidate(amendmentDate)) return false;
		else if (amendmentReasonIDs.length === 0) {
			this.props.showToastMessage('error', 'Amendment Reason is required. Please update.');
			return false;
		} else if (!this.props.amendContractReducer.updated) {
			this.props.showToastMessage('warning', 'No Changes to Save.');
			return false;
		}

		let selectedDate = new Date(amendmentDate);
		let dtUTC = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));
		const amendContractData = {
			markingTeamId,
			amendmentReasonIds: amendmentReasonIDs,
			amendmentNumber,
			type: appointmentType,
			qualificationYear: selectedYear,
			amendmentDate: dtUTC
		};
		await this.props.saveAmendContract(amendContractData);
		if (this.props.amendContractReducer.saveResponse === true) {
			this.props.showToastMessage('success', 'Successfully saved data.');
			this.refreshUIAfterDBChanges();
		} else this.props.showToastMessage('error', `Error occured while saving data. ${this.props.amendContractReducer.errors}`);
	};

	onDeleteClick = async () => {
		await this.props.deleteAmendContract(this.state.amendmentIDs);
		const {
			amendContractReducer: { deleteResponse }
		} = this.props;
		if (deleteResponse) {
			this.props.showToastMessage('success', 'Successfully deleted data.');
			this.refreshUIAfterDBChanges();
		} else this.props.showToastMessage('error', `Error occured while deleting data. ${this.props.amendContractReducer.errors}`);
	};

	refreshUIAfterDBChanges = () => {
		this.setState({ displaySubScreen: 'detailsTable', dbUpdate: true });
		this.fetchAmendContractDetails();
	};

	render() {
		const { onRefinementChange, onRefinerToggle } = this;

		let {
			selectedYear,
			contractTypes,
			keyField,
			apiCallCompleted,
			pageNo,
			total,
			pageSize,
			searchText,
			flagDetailsDisplay,
			markingTeamId,
			appointmentType,
			teamTitle,
			teamCode,
			amendContractDetails,
			amendmentReason,
			displaySubScreen,
			amendmentNumber,
			amendmentDate,
			amendmentReasonIDs,
			chkDeleteActionChecked,
			visibleTeams,
			refinerOpen,
			key
		} = this.state;

		let btnSelectDisable = visibleTeams && visibleTeams.length > 0 ? false : true;
		let displayScreen = '';
		if (!flagDetailsDisplay) {		
			displayScreen = (
				<AmendContractTeamTable
                    contractTypes={contractTypes}
                    apiCallCompleted={apiCallCompleted}
                    amendContractTeam={visibleTeams}
                    total={total}
                    keyField={keyField}
                    pageNo={pageNo}
                    pageSize={pageSize}
                    searchText={searchText}
                    markingTeamId={markingTeamId}
                    getExportData={this.getExportData}
                    onTeamTableChange={this.onTeamTableChange}
                    onSelectTeamRow={this.onSelectTeamRow}
                    searchYear={this.state.searchYear }
                    updateYear={ this.updateYear }
					key={key}
				/>
			);
		} else {
			displayScreen = (
				<AmendContractDetails
					selectedYear={selectedYear}
					contractTypes={contractTypes}
					apiCallCompleted={apiCallCompleted}
					amendContractDetails={amendContractDetails}
					keyField={'amendmentNumber'}
					appointmentType={appointmentType}
					teamTitle={teamTitle}
					teamCode={teamCode}
					amendmentReason={amendmentReason}
					displaySubScreen={displaySubScreen}
					amendmentNumber={amendmentNumber}
					amendmentDate={amendmentDate}
					amendmentReasonIDs={amendmentReasonIDs}
					chkDeleteActionChecked={chkDeleteActionChecked}
					getExportAmendContractDetails={this.getExportAmendContractDetails}
					onAddClick={this.onAddClick}
					onEditClick={this.onEditClick}
					onDeleteClick={this.onDeleteClick}
					onDateChange={this.onDateChange}
					onReaonsCheckboxChange={this.onReaonsCheckboxChange}
					onSubmitClick={this.onSubmitClick}
					onChangeDeleteCheckbox={this.onChangeDeleteCheckbox}
					key={key}
				/>
			);
		}

		return (
			<ErrorBoundary>
				<Page title="Contract Release Amend">
					<Section>
						<div style={{ margin: '2em' }}>
							<div className="container-fluid">
								<div ref={el => (this.componentRef = el)} style={{ marginBottom: '1.25em' }}>														
									<div className="paginator">
										<div>
											<YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={this.state.searchYear} updateYear={this.updateYear} />
										</div>
									</div>
									<Section>
										<Refiner
											disabled={false}
											fields={refinerFields}
											open={refinerOpen}
											data={this.state.refinerData}
											onRefinementChange={onRefinementChange}
											onPanelToggleClick={onRefinerToggle}
										/>
									</Section>
									{displayScreen}
									{flagDetailsDisplay && 
										<div className="SelectButtonCell" style={{ height: '5%', width: '100%' }}>
											<button
												ref={this.btnBack}
												disabled={btnSelectDisable}
												style={{
													height: '35px',
													width: '150px'
												}}
												onClick={this.onSelectClick}
												className="react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
											>
												Back
											</button>
										</div>
									}
								</div>
							</div>
						</div>
					</Section>
				</Page>
			</ErrorBoundary>
		);
	}
}

const mapStateToProps = state => {
	return {
		...state
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getAmendmentReason: async () => await dispatch(AmendContractActions.getAmendmentReason()),
		getAmendContractTeam: async (year, contractTypes, query) => await dispatch(AmendContractActions.getAmendContractTeam(year, contractTypes, query)),
		getAmendContractDetails: async (year, markingTeamId, contractTypes, query) =>
			await dispatch(AmendContractActions.getAmendContractDetails(year, markingTeamId, contractTypes, query)),
		saveAmendContract: async amendContractData => await dispatch(AmendContractActions.saveAmendContract(amendContractData)),
		deleteAmendContract: async amendContractIDs => await dispatch(AmendContractActions.deleteAmendContract(amendContractIDs)),
		addUpdateToAmendContract: formUpdates => dispatch(AmendContractActions.addUpdateToAmendContract(formUpdates)),
		clearAllAmendUpdates: () => dispatch(AmendContractActions.clearAllAmendUpdates()),
		showToastMessage: (severity, message) => dispatch(AmendContractActions.showToastMessage(severity, message))
	};
};





export default connect(mapStateToProps, mapDispatchToProps)(AmendContract);
